import { Col, DatePicker, Form, Row, Select } from 'antd';
import moment from 'moment';
import React, { useState } from 'react';
import Category_B2B from './Category_B2B';
import Category_B2BUR from './Category_B2BUR';
import Category_CDNR from './Category_CDNR';
import Category_CDNUR from './Category_CDNUR';
import Category_IMPS from './Category_IMPS';
const { RangePicker } = DatePicker;
const { Option } = Select;

const VolumeByPlaceOfSupply = props => {

    const categories = ["B2B", "B2BUR", "CDNR", "CDNUR", "IMPS"];
    const [selectedCategory, setSelectedCategory] = useState("B2B");
    const [selectedDates, setSelectedDates] = useState([moment().subtract(1, 'month').add(1, 'day'), moment()]);

    const PurchaseCategoryComponents = {
        "B2B": Category_B2B,
        "B2BUR": Category_B2BUR,
        "CDNR": Category_CDNR,
        "CDNUR": Category_CDNUR,
        "IMPS": Category_IMPS
    };
    const PurchaseCategoryComponent = PurchaseCategoryComponents[selectedCategory];

    function disabledDate(current) {
        return current && (current < moment("01-Apr-2017", "DD-MMM-YYYY") || current > moment().endOf('day'));
    }

    return (
        <div>
            <Form>
                <Row style={{ margin: 12 }}>
                    <Col span={12}>
                        <Form.Item label={<b>Category</b>} labelCol={{ span: 24 }} wrapperCol={{ span: 24 }}>
                            <Select
                                style={{ width: '100%', paddingRight: 12 }}
                                value={selectedCategory}
                                onChange={value => {
                                    setSelectedCategory(value);
                                }}
                            >
                                {categories && categories.map(category => <Option key={category}>{category}</Option>)}
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item label={<b>Date Range</b>} labelCol={{ span: 24 }} wrapperCol={{ span: 24 }}>
                            <RangePicker
                                style={{ width: '100%', paddingRight: 12 }}
                                defaultValue={selectedDates}
                                disabledDate={disabledDate}
                                format="DD-MMM-YYYY"
                                onChange={dates => setSelectedDates(dates)}
                                allowClear={false}
                            />
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
            <PurchaseCategoryComponent
                selectedDates={selectedDates}
            />
        </div>
    )
}

export default VolumeByPlaceOfSupply;